import Icon from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { UnixToDate } from '../../../../_config/utils/unix-to-date.util';
import { ColumnTitles } from '../constants/column-titles.constant';
import { handleNotificationClick } from '../../../../_config/functions/check-notification-and-mark-as-read';

export const generateColumns = (itemsDropdownStatus, status, currentSortOrder) => {
	return [
	
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'short_code',
			key: 'short_code',
		},
			{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].preorder,
			dataIndex: 'tracking_id',
			key: 'tracking_id',
			render: (tracking_id, record) => (
				<Link to={`/preorder/detail/${record.purchase_id}`}>
					{tracking_id}
				</Link>
			),
		},
			{
			title: ColumnTitles[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
			render: (trx_id) => (
				<Link to={`v2/tracking/detail/narma/${trx_id}`}>
					{trx_id}
				</Link>
			),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].pharmacy,
			dataIndex: 'pharmacy',
			key: 'pharmacy',
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].rut,
			dataIndex: 'user_info',
			key: 'rut',
			render: (record) => record.rut,
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].email,
			dataIndex: 'user_info',
			key: 'email',
			render: (record) => record.email,
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].createdAt,
			dataIndex: 'created_at',
			key: 'created_at',
			sorter: true, 
   	  sortOrder: currentSortOrder, 
			

			render: (createdAt) => UnixToDate(createdAt),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].detailOrder,
			dataIndex: 'detailOrder',
			key: 'detailOrder',
			render: (_, record) => {
				return (
					<Link
						to={`/quotation/detail/${record?.id}`}
						
						onClick={() => {
							console.log('record',record)
							handleNotificationClick(record?.id, record?.pharmacy)}}
					>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];
};
